<template>
  <NewsTab :market="COPPER.slug" />
</template>

<script lang="ts" setup>
import { useSeo } from '~/composables/useSeo'
import NewsTab from '~/components/market-insights/NewsTab.vue'
import { COPPER } from '~/constants/services/constants'

definePageMeta({ scrollToTop: false })

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: 'Copper Market Insights',
  description:
    'Read the latest Copper market insights from Benchmark, exploring the trends and dynamics central to the global supply chain.',
})
useHead(seo)
</script>
